import {useContext, useEffect} from "react";

import SkinBlock from "./SkinBlock";
import BuilderContext from "../../context/BuilderContext";


const Skin = () => {
    const { style, interactive } = useContext(BuilderContext)

    useEffect(() => {
        if (interactive) {
            document.title = style.title
        }
    }, [style.title, interactive])

    return (
        <>
            <SkinBlock />
        </>
    )
}

export default Skin